module.exports = __webpack_public_path__ + "static/copyrightlogo-56ab68e577f6727597ee61ddb6b5e623.png";